import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { vsDark } from "@code-surfer/themes";
import "prismjs/components/prism-haskell";
import "prismjs/components/prism-ruby";
import haskellLogo from "../../../../../../assets/haskell.png";
import drakeYes from "../../../../../../assets/drake-yes.png";
import drakeNo from "../../../../../../assets/drake-no.png";
import theFeels from "../../../../../../assets/the-feels.png";
import worthIt from "../../../../../../assets/worth-it.gif";
import { Me } from "../../../../../../Me";
import { Multiline } from "../../../../../../Multiline";
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  vsDark: vsDark,
  haskellLogo: haskellLogo,
  drakeYes: drakeYes,
  drakeNo: drakeNo,
  theFeels: theFeels,
  worthIt: worthIt,
  Me: Me,
  Multiline: Multiline,
  React: React
};